import {
  SsoGetSubjectAuthentications,
  SsogetUserRoleMenu,
  SsoGetUserInfo,
  TransformLogin
} from '@/api/login'
import { constantRouterMap } from '@/config/router.config'
import store from '@/store'
import { ACCESS_TOKEN, LANGUAGE } from '@/store/mutation-types'
import { openNotificationWithIcon } from '@/utils/util'
import NProgress from 'nprogress'
import Vue from 'vue'
import VueRouter from 'vue-router'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

let firstReadFlag = true

const router = new VueRouter({
  routes: constantRouterMap
})

NProgress.configure({
  easing: 'ease', // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
})

router.beforeEach(async (to, from, next) => {
  let lang = Vue.ls.get(LANGUAGE) || 'zh_CN'
  if (firstReadFlag) {
    await store.dispatch('SetLang', lang)
    firstReadFlag = false
  }
  console.log('to', to)
  NProgress.start()
  const { token, source, ...other } = to.query
  if (token) {
    window.localStorage.clear()
    Vue.ls.set(ACCESS_TOKEN, token)
    if (source === 'sso') {
      const { data } = await TransformLogin({
        targetPlatformCode: 'OPEN_API_PORTAL'
      })
      Vue.ls.set(ACCESS_TOKEN, data)
    }
    return next({
      ...to,
      query: other
    })
  }
  const accessToken = Vue.ls.get(ACCESS_TOKEN)
  if (accessToken) {
    if (!store.state.isLogin.hideInfo?.userId) {
      const { data } = await SsoGetUserInfo()
      store.commit('USER_INFO', data)
      store.commit('SET_SUBJECT_ID', data.onlineSubjectId)
      // 查询菜单
      await SsogetUserRoleMenu({ systemCode: 'OPEN_API_PORTAL' }).then((res) => {
        if (res.code === '200') {
          store.commit('SET_LEFT_MENU', res.data)
          store.commit('SET_IS_CHOICE_SUBJECT', false)
          store.commit('SET_LEFT_MENU_Loading', true)
        } else {
          openNotificationWithIcon(res.message)
        }
      }).finally(() => {
        store.commit('SET_LEFT_MENU_Loading', false)
      })
      // 根据主体区查询认证、审核状态
      if (data.onlineSubjectId) {
        const res = await SsoGetSubjectAuthentications({})
        const { code, message, dataList } = res
        if (code === '200') {
          store.commit('SET_COMPANY_INFO', dataList[0])
          store.dispatch('_SET_TO_OTHERMENU', (dataList || [])) // 判断是否能够进入其他菜单
        } else {
          openNotificationWithIcon(message)
        }
      }
      if (data.userType === 0) { // 此时登录后，需要去认证 弹窗
        store.commit('SET_IS_CREDENTIALS', true)
      } else {
        store.commit('SET_IS_CREDENTIALS', false)
      }
    }

    const { hideInfo } = store.getters
    if (!hideInfo.onlineSubjectId || (!store.state.isLogin.toOtherMenu)) {
      if (/^\/work/.test(to.path) && to.path !== '/work/credentials') {
        return next(false)
      }
    }
  }
  document.title = (store.getters.hideInfo.onlineSubjectName ? `${store.getters.hideInfo.onlineSubjectName}-` : '') + (lang === 'zh_CN' ? `易仓科技开放平台` : `ECCANG OP`)
  next()
})

// 当路由进入后：关闭进度条
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})

export default router
